import { SpecialAnchorTypes, ToolBaseTypes } from '@labradorsports/constants';

import { PluginContext } from '../../plugins/api.js';
import {
    createLines,
    generatePassAnchors,
    generatePassSelectedAnchors,
    getDefaultPassMove,
    handlePassDrag,
    handlePassDragEnd,
} from '../../utils/index.js';
import { getFootballToolFrameIdx } from '../move-placement-frame.js';
import PlayConfig from '../play-config.js';

const { ToolTypes } = PlayConfig;

const footballPassOptions = { defaultToMoveEnd: true };

export default {
    baseType: ToolBaseTypes.PASS,
    types: [ToolTypes.PASS, ToolTypes.SNAP, ToolTypes.HANDOFF, SpecialAnchorTypes.PASS_START],
    generateAnchors: generatePassAnchors,
    generateSelectedAnchors: generatePassSelectedAnchors,

    generateLines: ({ play }) => {
        if (play.fieldSetup) return [];

        return play.frameSnapshots.flatMap((frame, frameIdx) =>
            frame.visiblePasses(play.viewOptions).flatMap(createLines).map((line) => ({
                ...line,
                frameIdx,
            }))
        );
    },

    handleDragEnd: ({ api, play, lines, fieldViewport }, anchor, offset) => {
        const frameIdx = getFootballToolFrameIdx(anchor);
        const frame = play.frameSnapshots[frameIdx];

        const wrappedApi = {
            ...api,
            updatePass: (update) => {
                api.updatePass(update, frameIdx);
            },
        };

        handlePassDragEnd(
            { api: wrappedApi, play, lines, fieldViewport, frame },
            anchor,
            offset,
            footballPassOptions
        );
    },

    handleDrag({ play, lines, api, fieldViewport, frames }, anchor, offset) {
        const frameIdx = getFootballToolFrameIdx(anchor);
        const frame = frames[frameIdx];

        return handlePassDrag(
            {
                play,
                lines,
                api,
                frame,
                fieldViewport,
            },
            anchor,
            offset,
            footballPassOptions
        );
    },

    getDefaultMove({ play, lines, fieldViewport }, type, offset) {
        const frameIdx = getFootballToolFrameIdx({ type });
        const frame = play.frameSnapshots[frameIdx];

        return getDefaultPassMove({ play, lines, fieldViewport, frame }, type, offset, footballPassOptions);
    },
} as PlayPlugin<PluginContext>;
